module.exports = __webpack_public_path__ + "img/mainLogo2.6a4c91de.svg";